import './AllQuestions.css';
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useDarkMode } from "../../contexts/DarkModeContext";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router";
import { FaHistory, FaPaperPlane, FaChevronDown, FaChevronUp, FaTimes, FaPlus, FaRegClock } from "react-icons/fa";
import { 
  fetchInquiries, 
  setCurrentPage, 
  askInquiry, 
  answerInquiry, 
  fetchInquiryAnswers,
  clearAskInquiryError,
  clearAnswerInquiryError,
  addAnswerToInquiry,
  addInquiry
} from "../../redux/slices/inquiriesSlice";

function AllQuestions() {
    const { isDarkMode } = useDarkMode();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { 
      inquiries, 
      loading, 
      error, 
      pagination, 
      currentPage,
      askingInquiry,
      answeringInquiry,
      fetchingAnswers,
      inquiryAnswers,
      askInquiryError,
      answerInquiryError
    } = useSelector((state) => state.inquiries);
    const [activeTab, setActiveTab] = useState("الكل");
    const [expandedCards, setExpandedCards] = useState({});
    const [showAddModal, setShowAddModal] = useState(false);
    const [questionData, setQuestionData] = useState({
        title: '',
        content: '',
        subject: '',
        tags: ''
    });
    const [answerData, setAnswerData] = useState({});

    useEffect(() => {
        window.scrollTo(0, 0);
        // Fetch all inquiries for the questions page
        dispatch(fetchInquiries({ page: 1, limit: 5 }));
    }, [dispatch]);

    // Check if user is authenticated
    const isAuthenticated = !!localStorage.getItem("token3almny");



    const toggleCard = (index) => {
        setExpandedCards(prev => ({
            ...prev,
            [index]: !prev[index]
        }));
        
        // Fetch answers when expanding a card
        if (!expandedCards[index] && inquiries[index]) {
            dispatch(fetchInquiryAnswers({ inquiryId: inquiries[index].id }));
        }
    };

    const openAddModal = () => {
        setShowAddModal(true);
        document.body.style.overflow = 'hidden';
    };

    const closeAddModal = () => {
        setShowAddModal(false);
        document.body.style.overflow = 'unset';
        setQuestionData({
            title: '',
            content: '',
            subject: '',
            tags: ''
        });
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setQuestionData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleAnswerInputChange = (inquiryId, value) => {
        setAnswerData(prev => ({
            ...prev,
            [inquiryId]: value
        }));
    };

    const handleSubmitAnswer = (inquiryId) => {
        const answerText = answerData[inquiryId];
        if (answerText && answerText.trim()) {
            // Create a temporary answer object for immediate display
            const tempAnswer = {
                id: Date.now(), // Temporary ID
                answer: answerText,
                user_name: "أنت", // You can get this from user state
                user_image: "/user.png", // You can get this from user state
                created_at: new Date().toISOString()
            };

            // Add the answer immediately to the state
            dispatch(addAnswerToInquiry({ inquiryId, answer: tempAnswer }));

            // Clear the answer input immediately
            setAnswerData(prev => ({
                ...prev,
                [inquiryId]: ''
            }));

            // Send the answer to the server
            dispatch(answerInquiry({ inquiryId, text: answerText }))
                .then((result) => {
                    if (result.error) {
                        // If there's an error, remove the temporary answer
                        // You might want to show an error message here
                        console.error('Failed to send answer:', result.error);
                    }
                });
        }
    };

    const handleSubmitQuestion = (e) => {
        e.preventDefault();
        if (questionData.content.trim()) {
            // Create a temporary inquiry object for immediate display
            const tempInquiry = {
                id: Date.now(), // Temporary ID
                text: questionData.content,
                user_name: "أنت", // You can get this from user state
                user_image: "/user.png", // You can get this from user state
                created_at: new Date().toISOString()
            };

            // Add the inquiry immediately to the state
            dispatch(addInquiry({ inquiry: tempInquiry }));

            // Close modal immediately
            closeAddModal();

            // Send the inquiry to the server
            dispatch(askInquiry({ text: questionData.content }))
                .then((result) => {
                    if (result.error) {
                        // If there's an error, you might want to show an error message
                        console.error('Failed to send inquiry:', result.error);
                    }
                });
        }
    };

    // Handle page change
    const handlePageChange = (page) => {
        dispatch(setCurrentPage(page));
        dispatch(fetchInquiries({ page, limit: 3 }));
    };

    // Format date for display
    const formatDate = (dateString) => {
        if (!dateString) return "27 Jan, 2024";
        
        try {
            const date = new Date(dateString);
            return date.toLocaleDateString('en-US', {
                day: 'numeric',
                month: 'short',
                year: 'numeric'
            });
        } catch (error) {
            return "27 Jan, 2024";
        }
    };

    const tabs = [
        "الكل",
        "علوم",
        "الدراسات الاجتماعية",
        "اللغة الإنجليزية",
        "الرياضيات",
        "جغرافيا"
    ];

    const subjects = [
        { name: "الرياضيات", icon: "/math.png" },
        { name: "الدراسات الاجتماعية", icon: "/drasat.png" },
        { name: "اللغة العربية", icon: "/arabic.png" },
        { name: "العلوم", icon: "/science.png" },
        { name: "جغرافيا", icon: "/gohraphia.png" },
        { name: "فيزياء", icon: "/physic.png" },
        { name: "اللغة الإنجليزية", icon: "/english.png" },
        { name: "تاريخ", icon: "/tarekh.png" },
    ];

    const filteredLessons = activeTab === "الكل"
        ? subjects
        : subjects.filter(subject => subject.name === activeTab);

    // بيانات المستخدمين للإجابات
    const answerUsers = [
        { name: "أحمد إبراهيم", image: "/user.png" },
        { name: "سارة محمد", image: "/user.png" },
        { name: "علي حسن", image: "/user.png" },
        { name: "فاطمة أحمد", image: "/user.png" },
        { name: "محمد علي", image: "/user.png" }
    ];

    return (
        <div className={`questions-section ${isDarkMode ? 'dark-mode' : 'light-mode'}`}>
            <div className="container">
                {/* Breadcrumb */}
                <div className="lessons-breadcrumb">
                    <h1 className="breadcrumb-title">سؤال وجواب</h1>
                    <div className="breadcrumb-links2">
                        <span className="breadcrumb-link">الرئيسية</span>
                        <span className="breadcrumb-separator">/</span>
                        <span className="breadcrumb-current">سؤال وجواب</span>
                    </div>
                </div>

                {/* Add Question Button and History Button */}
                <div className="questions-section-buttons d-flex justify-content-between align-items-center mb-4">
                    <div className="d-flex gap-3">
                        <button className="add-question-btn" onClick={openAddModal}>
                            <span className="icon">➕</span> إضافة سؤال
                        </button>
                        <button className="history-btn">
                            <FaHistory />
                        </button>
                    </div>
                </div>

                {/* Loading State */}
                {loading && (
                    <div className="text-center my-4">
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">جاري التحميل...</span>
                        </div>
                    </div>
                )}

                {/* Questions Cards */}
                <div className="questions-section-list">
                    {inquiries.length > 0 ? (
                        inquiries.map((inquiry, index) => (
                            <div key={inquiry.id || index} className="questions-section-card">
                                <div className="questions-section-header d-flex align-items-start justify-content-between">
                                    <div className="d-flex align-items-center gap-3">
                                        <img 
                                            src={inquiry.user_image || "/user.png"} 
                                            alt="user" 
                                            className="questions-section-user-img"
                                            onError={(e) => {
                                                e.target.src = "/user.png";
                                            }}
                                        />
                                        <div>
                                            <h6 className="questions-section-user-name">
                                                {inquiry.user_name || "مستخدم"}
                                            </h6>
                                            <div className="d-flex align-items-center gap-2 mb-2">
                                                <FaRegClock style={{ fontSize: "12px", color: "#666" }} />
                                                <span style={{ fontSize: "12px", color: "#666" }}>
                                                    {formatDate(inquiry.created_at)}
                                                </span>
                                            </div>
                                            <p className="questions-section-question-text">
                                                {inquiry.text || "لماذا تظهر السماء باللون الأزرق خلال اليوم ولكن تتحول إلى اللون الأحمر عند غروب الشمس؟"}
                                            </p>
                                        </div>
                                    </div>
                                    <button 
                                        className="questions-section-toggle-btn"
                                        onClick={() => toggleCard(index)}
                                    >
                                        {expandedCards[index] ? <FaChevronUp /> : <FaChevronDown />}
                                    </button>
                                </div>

                                {/* الإجابات */}
                                {expandedCards[index] && (
                                    <div className="questions-section-answers mt-3">
                                        {fetchingAnswers ? (
                                            <div className="text-center">
                                                <div className="spinner-border text-primary" role="status">
                                                    <span className="visually-hidden">جاري تحميل الإجابات...</span>
                                                </div>
                                            </div>
                                        ) : inquiryAnswers[inquiry.id] && inquiryAnswers[inquiry.id].length > 0 ? (
                                            inquiryAnswers[inquiry.id].slice().reverse().map((answer, i) => (
                                                <div key={i} className="questions-section-answer d-flex mb-3">
                                                    <img 
                                                        src={answer.user_image || "/user.png"} 
                                                        alt={answer.user_name || "مستخدم"} 
                                                        className="questions-section-answer-user-img"
                                                        onError={(e) => {
                                                            e.target.src = "/user.png";
                                                        }}
                                                    />
                                                    <div>
                                                        <h6 className="questions-section-answer-name">
                                                            {answer.user_name || "مستخدم"}
                                                        </h6>
                                                        <p className="questions-section-answer-text">
                                                            {answer.answer || answer.text || answer.answer_text}
                                                        </p>
                                                    </div>
                                                </div>
                                            ))
                                        ) : (
                                            <div className="text-center">
                                                <p>لا توجد إجابات بعد</p>
                                            </div>
                                        )}
                                    </div>
                                )}

                                {/* Comment Input Section */}
                                <div className="questions-section-comment-input mt-3">
                                    <div className="d-flex align-items-center gap-2">
                                        <img src="/user.png" alt="user" className="questions-section-comment-user-img" />
                                        <div className="comment-input-wrapper flex-grow-1">
                                            <input 
                                                type="text" 
                                                placeholder="اكتب إجابتك هنا..." 
                                                className="comment-input"
                                                value={answerData[inquiry.id] || ''}
                                                onChange={(e) => handleAnswerInputChange(inquiry.id, e.target.value)}
                                                onKeyPress={(e) => {
                                                    if (e.key === 'Enter') {
                                                        handleSubmitAnswer(inquiry.id);
                                                    }
                                                }}
                                            />
                                        </div>
                                        <button 
                                            className="send-comment-btn"
                                            onClick={() => handleSubmitAnswer(inquiry.id)}
                                            disabled={answeringInquiry}
                                        >
                                            {answeringInquiry ? (
                                                <div className="spinner-border spinner-border-sm" role="status">
                                                    <span className="visually-hidden">جاري الإرسال...</span>
                                                </div>
                                            ) : (
                                                <FaPaperPlane />
                                            )}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        ))
                    ) : (
                        <div className="text-center w-100">
                            <p>لا توجد أسئلة متاحة</p>
                        </div>
                    )}
                </div>

                {/* Pagination */}
                {isAuthenticated && pagination && (
                  <div className="pagination-container mt-4">
                    <div className="pagination">
                      {Array.from({ length: pagination.pages_count || 1 }, (_, i) => i + 1).map((page) => (
                        <button
                          key={page}
                          className={`pagination-btn ${currentPage === page ? 'active' : ''}`}
                          onClick={() => handlePageChange(page)}
                        >
                          {page}
                        </button>
                      ))}
                    </div>
                  </div>
                )}


            </div>

            {/* Add Question Modal */}
            {showAddModal && (
                <div className="questions-modal-overlay"  onClick={closeAddModal}>
                    <div className="questions-modal-content"   onClick={(e) => e.stopPropagation()}>
                        <div className="questions-modal-header">
                            <h3 className="questions-modal-title">
                                <FaPlus className="questions-modal-icon" />
                                إضافة سؤال جديد
                            </h3>
                            <button className="questions-modal-close" onClick={closeAddModal}>
                                <FaTimes />
                            </button>
                        </div>
                        
                        <form onSubmit={handleSubmitQuestion} className="questions-modal-form">
                            {askInquiryError && (
                                <div className="alert alert-danger" role="alert">
                                    {askInquiryError}
                                </div>
                            )}
                            <div className="questions-form-group">
                                <label className="questions-form-label">تفاصيل السؤال</label>
                                <textarea
                                    name="content"
                                    value={questionData.content}
                                    onChange={handleInputChange}
                                    className="questions-form-textarea"
                                    placeholder="اكتب تفاصيل السؤال هنا..."
                                    rows="4"
                                    required
                                />
                            </div>

                            <div className="questions-modal-actions">
                                <button type="button" className="questions-modal-cancel" onClick={closeAddModal}>
                                    إلغاء
                                </button>
                                <button type="submit" className="questions-modal-submit" disabled={askingInquiry}>
                                    {askingInquiry ? (
                                        <>
                                            <div className="spinner-border spinner-border-sm me-2" role="status">
                                                <span className="visually-hidden">جاري الإرسال...</span>
                                            </div>
                                            جاري الإرسال...
                                        </>
                                    ) : (
                                        <>
                                            <FaPlus />
                                            إضافة السؤال
                                        </>
                                    )}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
}

export default AllQuestions;
